import React, { memo, useRef, useState } from "react";
import { PhotoLibraryIcons } from "../../../../utils/B2B/PhotoLibraryContent";
import "./PhotoLibraryHeader.scss";

interface PhotoLibraryHeaderProps {
	onAddSection: () => void;
	onClose: () => void;
}

const PhotoLibraryHeader: React.FC<PhotoLibraryHeaderProps> = ({ onClose, onAddSection }) => {
	const [showInfoTooltip, setShowInfoTooltip] = useState(false);
	const infoTooltipRef = useRef<HTMLDivElement>(null);

	return (
		<div className="picker-header">
			<div className="picker-header-content">
				<div className="picker-title-wrapper">
					<h3>Add Photos</h3>
					<div className="info-icon-wrapper" ref={infoTooltipRef}>
						<div className="info-icon-wrapper-content">
							<button
								className="info-icon-btn"
								onClick={() => setShowInfoTooltip(!showInfoTooltip)}
								onMouseEnter={() => setShowInfoTooltip(true)}
								onMouseLeave={() => setShowInfoTooltip(false)}
							>
								<PhotoLibraryIcons.Info />
							</button>
							<button className="add-section-btn" onClick={onAddSection} title="Add section">
								<PhotoLibraryIcons.Plus />
							</button>
						</div>
						{showInfoTooltip && (
							<div className="info-tooltip">
								<div className="tooltip-item">
									<PhotoLibraryIcons.ArrowUp />
									<span>Photos uploaded are automatically added to your library</span>
								</div>
								<div className="tooltip-item">
									<PhotoLibraryIcons.DragDrop />
									<span>Drag and drop photos to sections to organize them</span>
								</div>
								<div className="tooltip-item">
									<PhotoLibraryIcons.FolderPlus />
									<span>Create custom sections for better organization</span>
								</div>
								<div className="tooltip-item">
									<PhotoLibraryIcons.Trash />
									<span>Delete unwanted images from your library</span>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
			<button className="picker-close" onClick={onClose}>
				<PhotoLibraryIcons.Close />
			</button>
		</div>
	);
};

export default memo(PhotoLibraryHeader);
